import { useTranslation, Trans } from "react-i18next";

import { Dialog } from 'primereact/dialog';

export default function Upsilon({visible, setVisible}) {

    const { t } = useTranslation();

    return(
        <Dialog header="Upsilon" visible={visible} style={{ width: '50vw' }} onHide={() => {if (!visible) return; setVisible(false); }} className="upsilonPanel">
            <Trans i18nKey="upsilonDetails" />

            <a href="https://touist.irit.fr/" target="_blank" className="text-center block">TouIST</a>

            <h2 className="text-center titles text-pink-300">{t("technologies")}</h2>

            <p className="text-center">Electron, ReactJs, NodeJs, Typescript, Python, Flask, Git, SonarQube, JWT, REST Api, SCRUM</p>
        </Dialog>
    )
}